import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ShopRelationTextButton from '../atoms/ShopRelationTextButton';
import RelationOnButton from '../atoms/RelationOnButton';
import RelationOffButton from '../atoms/RelationOffButton';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    shops,
    emptyRows,
    page,
    rowsPerPage,
    order,
    orderBy,
    roles,
    shopRelationAction
  }) => {
    let sortedResult;
    if (orderBy === 'streetAddress') {
      sortedResult = _.orderBy(
        shops,
        ['prefectures', 'city', 'address', 'building'],
        [order, order, order, order]
      );
    } else if (orderBy === 'shopStatus') {
      sortedResult = _.orderBy(shops, ['status'], [order]);
    } else {
      sortedResult = _.orderBy(shops, orderBy, order);
    }
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            const key = `${shop.shopId}-${shop.groupId}`;
            const onClickParams = {
              shopId: shop.shopId,
              shopName: shop.shopName,
              otherGroupBankAccount:
                shop.groupId === null && shop.groupDepositManage === 'NONSELF',
              stripeUseSwitchable: shop.stripeUseSwitchable
            };

            let titleStatus = '';
            if (shop.status === 'AVAILABLE') {
              titleStatus = '利用可能';
            } else if (shop.status === 'PRE_AVAILABLE') {
              titleStatus = '準備中';
            } else if (shop.status === 'SUSPENDED') {
              titleStatus = '利用停止中';
            } else if (shop.status === 'CLOSED') {
              titleStatus = '閉店';
            }

            return (
              <TableRow key={key}>
                {(roles.isGroup || roles.isSecretariat) && (
                  <TableCell>
                    <ShopRelationTextButton
                      onClickAction={shopRelationAction}
                      onClickParams={onClickParams}
                      disabled={shop.groupId !== null}
                    />
                  </TableCell>
                )}
                {(roles.isGroup || roles.isSecretariat) &&
                  shop.groupId === null && (
                    <TableCell>
                      <RelationOffButton />
                    </TableCell>
                  )}
                {(roles.isGroup || roles.isSecretariat) &&
                  shop.groupId !== null && (
                    <TableCell>
                      <RelationOnButton />
                    </TableCell>
                  )}
                <TableCell>{shop.shopId}</TableCell>
                <TableCell>{shop.shopName}</TableCell>
                <TableCell>{titleStatus}</TableCell>
                <TableCell>
                  {shop.prefectures}
                  {` `}
                  {shop.city}
                  {` `}
                  {shop.address}
                  {` `}
                  {shop.building}
                </TableCell>
                <TableCell>{shop.phone}</TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
